export const CONNECTION_LABELS = {
  disconnected: 'Disconnected',
  connecting: 'Connecting…',
  connected: 'Streaming',
  paused: 'Paused',
  error: 'Error',
}

export const CONTROL_PANEL_MIN_WIDTH = 280
export const CONTROL_PANEL_MAX_WIDTH = 520
export const DEFAULT_CONTROL_PANEL_WIDTH = 320
